export default {"src":"/_next/static/media/AmputationsLoss.c2fad5cd.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};